<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text">
          Категории
        </span>
        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>
      </div>
      <v-btn @click="goToCreate" style="width: auto !important" class=" button-accept">
        + Добавить категорию
      </v-btn>
    </div>

    <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">
            «Категории новостей»
          </div>
          <div class="menu-container-text">
            Настраиваемый спискок для фильтрации новостей в мобильном приложении
          </div>

        </div>

      </v-card>
    </v-menu>

    <div>

      <v-data-table :headers="tableHeaders" :items="categories" item-key="id" :show-select="false"
        :disable-pagination="true" :hide-default-footer="true">

        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in props.items" :key="index">
              <td>
                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>
              <td style="max-width: 100px !important"> {{ index + 1 }} </td>
              <td>
                <img style="width:24px" :src="item.androidIcon">
              </td>

              <td>
                {{ item.name }}
              </td>
              <td>
                <v-icon @click="goToDetail(item)" style="cursor: pointer">
                  mdi-pencil-outline
                </v-icon>

              </td>

            </tr>
          </draggable>
        </template>

      </v-data-table>


    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    categories: [],
    moveItems: false,
    selectedDrag: '',
    tableHeaders: [
      {
        text: '',
        sortable: false
      },
      {
        text: 'Порядок отображения',
        value: '',
        sortable: false
      },
      {
        text: 'Иконка',
        sortable: false,
        value: 'icon',

      },
      {
        text: 'Название',
        sortable: false,
        value: 'name',
      },
      {
        text: '',
        sortable: false,
        value: 'actions',
      },

    ],
  }),
  methods: {
    openInfo(e) {

      e.preventDefault()

      this.x = e.clientX + 10
      this.y = e.clientY + 10
      this.showInfo = true
    },
    goToCreate() {
      this.$router.push({ name: 'CreateCategories' })

    },
    goToDetail(item) {
      this.$router.push({ name: 'EditCategories', params: { id: item.id } })

    },
    getCategories() {
      this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/category/list', {


      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(res => {

          this.categories = res.data.items

        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })

    },
    endDrag(evt) {

      this.moveItems = true
      this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/category/sort', {
        categoryId: this.selectedDrag,
        index: evt.newIndex + 1

      }, {
        headers: {
          'authorization': this.$store.getters.adminPanelHeaderAuth
        }
      })
        .then(() => {
          this.getCategories()
          this.moveItems = false


        })
        .catch(err => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        })

    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id
    },


  },
  created() {
    this.getCategories()
  },
}
</script>
<style lang="scss" scoped></style>